import { useChargingFeeDiscountTypeEnum } from '@services/chargingFee'
import { Select, SelectProps } from '@shared/Form/Select'

export const ChargingFeeDiscountTypeSelect = (props: SelectProps<number[]>) => {
  const { data } = useChargingFeeDiscountTypeEnum()

  return (
    <Select allowClear {...props}>
      {(data || []).map(({ id, label }) => (
        <Select.Option key={id} value={id}>
          {label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ChargingFeeDiscountTypeSelect
